import { stringify } from 'query-string';

import { ExitReason, FetchFoodTrayTemplatesFilters, FoodItem, FoodTray, FoodTrayTemplate } from '../models';
import { Network } from '../utils';

function sortFoodLines(template: FoodTrayTemplate) {
  template.foodLines = (template?.foodLines || []).sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  );
  return template;
}

export const getFoodTrayTemplates = async (filters: FetchFoodTrayTemplatesFilters): Promise<FoodTrayTemplate[]> => {
  const templates = await Network.get(`foodTrayTemplates?${stringify(filters)}`);
  return templates.map(sortFoodLines);
};

export const getFoodTrayTemplate = async (id: string): Promise<FoodTrayTemplate> => {
  const template = await Network.get(`foodTrayTemplates/${id}`);
  return sortFoodLines(template);
};

export const duplicateFoodTrayTemplate = async (id: string) => {
  return Network.post(`foodTrayTemplates/${id}/duplicate`);
};

export const createFoodTrayTemplate = (template: Partial<FoodTrayTemplate>) => {
  return Network.post('foodTrayTemplates', template);
};

export const updateFoodTrayTemplate = (id: string, template: Partial<FoodTrayTemplate>) => {
  return Network.patch(`foodTrayTemplates/${id}`, template);
};

export const deleteFoodTrayTemplate = async (id: string) => Network.delete(`foodTrayTemplates/${id}`);

export const startTimer = (foodItem: Partial<FoodItem>) => Network.post('foodItems', foodItem);
export const startTimerForExistingFoodItem = (foodItem: Partial<FoodItem>) => Network.patch(`foodItems/${foodItem.id}`, foodItem);
export const replaceFoodItem = (foodItem: Partial<FoodItem>) => Network.post('foodItems', foodItem);
export const emptyFoodTray = async (foodTray: FoodTray, exitReason: ExitReason) => {
  const response = await Network.delete(`foodItems/${foodTray?.foodItem?.id}?exitReason=${exitReason}`);
  if (foodTray.foodItem.overrideFoodType) {
    // food tray had its food item changed, so we should set a ned food item
    const newFoodItem: Partial<FoodItem> = {
      overrideFoodType: foodTray.foodItem.overrideFoodType,
      foodTray: { id: foodTray.id } as FoodTray,
    };
    await Network.post('foodItems', newFoodItem);
  }
  return response;
};
export const emptyFoodLine = (id: string) => Network.delete(`foodLines/${id}/empty`);
